<template>
  <div
    v-if="loading"
    role="status"
    class="animate-pulse bg-bgr-200"
    :style="{ height: `${RAIL_HEIGHT_REM}rem` }"
    data-allow-mismatch
  />

  <VueSlider
    v-else
    v-model="model"
    :min="totalMin"
    :max="totalMax"
    :disabled
    :tooltip="'none'"
    :dot-size="`${DOT_SIZE_REM}rem`"
    :dot-options="{ min, max }"
    :rail-style="{
      height: `${RAIL_HEIGHT_REM}rem`,
      background: disabled ? colors.background200 : colors.border,
    }"
    :process-style="{
      background: disabled ? colors.border : colors.themeActive,
    }"
    @drag-end="handleDragEnd"
  >
    <template #dot>
      <div
        class="rounded-full bg-bgr-50 border border-thm-active cursor-pointer"
        :style="{ width: `${DOT_SIZE_REM}rem`, height: `${DOT_SIZE_REM}rem` }"
      ></div>
    </template>
  </VueSlider>
</template>

<script setup lang="ts">
import VueSlider from 'vue-3-slider-component'

const DOT_SIZE_REM = 2
const RAIL_HEIGHT_REM = 0.25

defineProps<{
  totalMin: number
  totalMax: number
  min: number
  max: number
  disabled?: boolean
  loading?: boolean
}>()

const emit = defineEmits<{ change: [value: NumInterval] }>()

const model = defineModel<NumInterval>({ required: true })

const colors = useColors()

function handleDragEnd() {
  emit('change', model.value)
}
</script>
